export default __webpack_public_path__ + "static/media/english_workshop_image.4b1b2d7b.png";